/**
 * Created by WebStorm.
 * User: liulin
 * Date: 2018/9/6
 * Time: 上午11:23
 */
import { Store, Storage } from '../common'
import {
  deleteStr,
  getOpsObj,
  getOpsRetainLength,
  rollback
  // isInsert,
  // isDelete,
  // compose
} from '../../lib/ot'
import _ from 'lodash'
import Quill from 'quill'

const Delta = Quill.import('delta')

/**
 * 获取上次（本次操作前）的光标位置
 * @param deltaData
 * @param type (0：表示insert操作，1表示delete操作，2表示retain操作)
 * @return {number}
 */
export function getLastCursorPosition (type, deltaData) {
  let lastIndex = 0
  if (deltaData && deltaData.length > 0) {
    switch (type) {
      case 0:
        lastIndex = deltaData.length === 1 ? 0 : deltaData[0].retain
        break
      case 1:
        if (deltaData.length === 1) {
          lastIndex = deltaData[0].retain ? deltaData[0].retain : deltaData[0].delete
        } else {
          lastIndex = deltaData[0].retain + deltaData[1].delete
        }
        break
      case 2:
        // lastIndex = deltaData.length === 1 ? 1 : deltaData[0].retain + deltaData[1].retain
        lastIndex = deltaData.reduce((prev, item) => {
          if (!item.retain) return
          return prev + item.retain
        }, 0)
        break
      default:
    }
  }
  return lastIndex
}

/**
 * 通过delta来返回相应的数据，用来处理非直接输入，比如中文输入
 * @param delta
 * @return {Array}
 */
export function getChineseDelta (delta) {
  let deltaData = []
  const lastDelta = delta[delta.length - 1]
  const lastStringObj = _.find(lastDelta, item => item.insert)
  const firstDelta = delta[0]
  const isChinese = lastStringObj ? /[\u4e00-\u9fa5]|\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/.test(lastStringObj.insert) : false

  const lastIndex = getOpsRetainLength(firstDelta) || 0
  const attributesObj = _.find(firstDelta, item => item.attributes)
  let insertTextAttr = {
    insert: '',
    attributes: attributesObj && attributesObj.attributes
  }

  if (isChinese) {
    let insertObj = _.find(lastDelta, item => item.insert)
    insertTextAttr.insert = insertObj && insertObj.insert
  } else {
    let text = ''
    delta.map((item) => {
      let opsObj = getOpsObj(item)
      const opsRetainLength = getOpsRetainLength(item)
      if (opsObj.insert) text += opsObj.insert
      if (opsObj.delete) text = deleteStr(text, opsRetainLength - lastIndex, opsObj.delete)
    })

    if (!text) return []
    insertTextAttr.insert = _handleText(text)
  }

  deltaData.push({retain: lastIndex})
  deltaData.push(insertTextAttr)

  return deltaData
}

function _handleText (text) {
  let textFirst = text.substr(0, text.length / 2)
  let textSec = text.substr(text.length / 2)
  if (textFirst.toLocaleUpperCase() === textSec) {
    return textSec.replace(/'/g, '')
  } else {
    return text.replace(/'/g, '')
  }
}

/**
 * 获取socket需要的changeset
 * @param curSelectLength 当前选中长度
 * @param curTextLength 当前编辑器中文本的总长度
 * @param type (0：表示insert操作，1表示delete操作，2表示retain操作)
 * @param deltaData
 * @return {{selection: number|*, text: string, length: number, style: {}}}
 */
export function getChangesetByType (curSelectLength, curTextLength, type, deltaData) {
  let isInsert = deltaData.some(item => item.insert)
  if (!curSelectLength || curSelectLength === 0) curSelectLength = 1
  let lastCursorPosition = curTextLength === 2 && isInsert ? 0 : getLastCursorPosition(type, deltaData)
  let changeset = [lastCursorPosition]

  if (isSelectAll() && curTextLength !== 2 && curTextLength !== 1) changeset[0] = curSelectLength
  switch (type) {
    case 0:
      deltaData.map((item) => {
        // if (item.retain) {
        //   changeset.push({
        //     length: item.retain,
        //     style: item.attributes
        //   })
        // }
        if (item.insert) {
          let text = item.insert
          let style = item.attributes ? item.attributes : {}
          changeset.push({
            text,
            style
          })
        }
      })
      break
    case 1:
      let deleteData = _.find(deltaData, item => item.delete)
      let length = deleteData ? deleteData.delete : 1
      changeset.push({
        length
      })
      break
    case 2:
      let retainData = _.filter(deltaData, item => item.retain)

      retainData.map((item) => {
        let style = item.attributes ? item.attributes : null
        changeset.push({
          length: item.retain,
          style
        })
      })
      break
    default:
      return
  }
  return changeset
}

/**
 * 处理选中部分多种样式的情况
 * @param quill
 * @param delta
 */
export function handleSelectStyle (quill, delta) {
  if (selectLength() === 0) return
  let curSelectStyle = getStyle(quill)
  let deltaStyle = _.find(delta, item => item.attributes)
  if (deltaStyle && !_.isEmpty(curSelectStyle)) {
    deltaStyle.attributes = curSelectStyle
  }
}

/**
 * 设置当前匹配成功的两个\n在一起的类型，下面是种类（string）：
 * codeMarkdown: 表示直接输入``` + 空格,形成的两个\n在一起的情况
 * codeDelete: 表示在代码块中将代码块的内容全部删完后,形成的两个\n在一起的情况
 * codeWrap: 不管怎么形成的只要是代码块没有内容,形成的两个\n在一起的情况
 * inlineWrap: 表示在拥有行内元素的某一行回车后,形成的两个\n在一起的情况
 * deleteWrap: 表示在正常字符内容的某行全部删完后,形成的两个\n在一起的情况
 * blockWrap: 表示在拥有块级元素的某一行回车后,形成的两个\n在一起的情况
 * @param self
 * @param delta
 */
export function handleWrapType (self, delta) {
  let cursorPosition = getCurCursorPosition(self.quill)
  if (!cursorPosition) return // 光标位置不存在，当前编辑器失去了焦点

  let isDelete = delta.some(item => item.delete)
  let isInsert = delta.some(item => item.insert)
  let isBlockInsert = isInsert && delta.some((item) => {
    return item.attributes && item.attributes.header // 这边以后或许要扩展
  })

  if (isInsert) cursorPosition = cursorPosition + 1

  let preText = self.quill.getText(cursorPosition - 1, 1)
  let nextText = self.quill.getText(cursorPosition, 1)
  let curLineStyle = self.quill.getFormat()
  let baseCondition = preText === '\n' && nextText === '\n'

  if (!baseCondition) return // 不满足两个换行符在一起的情况

  if (isInsert) wrapType('inlineWrap')
  if (isBlockInsert) wrapType('blockWrap')
  if (isDelete) wrapType('deleteWrap')
  if (curLineStyle['code-block'] && !isInsert) wrapType('codeWrap')
  console.log('换行匹配结果', wrapType())

  if (wrapType() && wrapType() !== 'codeWrap') handleWrap(self)
}

/**
 * 处理两个换行符在一起的不同情况
 * @param self
 */
export function handleWrap (self) {
  switch (wrapType()) {
    case 'codeWrap':
      if (deleteLock()) _handleCodeBlockDelete(self)
      break
    case 'inlineWrap':
      _handleInlineWrap(self)
      break
    case 'blockWrap':
      _handleBlockWrap(self)
      break
    case 'deleteWrap':
      _handleDeleteWrap(self)
      break
    default:
  }
  wrapType('') // 处理完成后要将curWrapType置空
}

/**
 * 处理inlineWrap操作
 * @param self
 * @private
 */
function _handleInlineWrap (self) {
  console.log('执行了处理inlineWrap操作')
}

/**
 * 处理blockWrap操作
 * @param self
 * @private
 */
function _handleBlockWrap (self) {
  console.log('执行了处理blockWrap操作')
  let cursorPosition = getCurCursorPosition(self.quill)
  setTimeout(() => {
    self.quill.updateContents(new Delta()
      .retain(cursorPosition + 1)
      .retain(1, {header: null})
    )
  }, 50)
  console.log('cursorPosition', cursorPosition)
}

/**
 * 处理deleteWrap操作
 * @param self
 * @private
 */
function _handleDeleteWrap (self) {
  // 处理这种情况要格外小心，因为它跟很多情况冲突了，比如markdown语法
  // 有些是经过添加、删除、保留的操作完成的。在删除那一步很可能跟这种
  // 类型产生冲突
  console.log('执行了处理deleteWrap操作')
  // let cursorPosition = getCurCursorPosition(self.quill)
  // self.quill.updateContents(new Delta()
  //   .retain(cursorPosition)
  //   .retain(1, {})
  // )
  // console.log('cursorPosition', cursorPosition)
}

/**
 * 处理代码块没有内容的最后一次操作
 * @param self
 * @private
 */
function _handleCodeBlockDelete (self) {
  console.log('执行了处理code delete操作')
  isSyncing(true) // 将发送消息锁住
  // self.quill.format('code-block', null)
  self.quill.insertText(getCurCursorPosition(self.quill), '\n')

  // let deltaData = []
  // deltaData.push({retain: getCurCursorPosition(self.quill)})
  // deltaData.push({
  //   attributes: {'code-block': null},
  //   retain: 1
  // })
  // self.$emit('send-message', deltaData)
  deleteLock(false)
  isSyncing(false) // 解开发送消息的锁
}

/**
 * 返回当前缓存池里面操作
 * @param cacheOps
 * @return {*}
 */
export function curCacheOps (cacheOps) {
  if (typeof cacheOps !== 'undefined') {
    Store.store('curCacheOps', cacheOps)
  } else {
    return Store.store('curCacheOps')
  }
}

/**
 * 输入中文期间受到的消息会被缓存在这里，是个三维数组，也就是changeData的一个集合
 * @param syncMessage
 * @return {*}
 */
export function syncMessageCache (syncMessage) {
  if (typeof syncMessage !== 'undefined') {
    Store.store('syncMessageCache', syncMessage)
  } else {
    return Store.store('syncMessageCache')
  }
}

/**
 * 处理影响队列里面的数据
 * @return {*}
 */
export function handleOwnOperationQueue () {
  // 先翻转后去重，因为我们没有收到自己的消息的时候是不会发出当前客户端的缓存的，
  // 所以我没有去改变uuid，导致下一次输入的缓存uuid跟上一次一样的，但是经过合并
  // 后这一次的消息里面肯定是包含了上一次的内容的，所以直接去除更老的消息就可以
  // 正确去除重复的数据
  ownOperationQueue(_.uniqBy(ownOperationQueue().reverse(), 'uuid'))

  // 深拷贝一份去重后的队列，我们待会返回一份新的队列出去，
  // 原来的那一份要用来维护这个影响队列的增减
  let ownQueue = _.cloneDeep(ownOperationQueue().reverse())
  ownQueue.map((item, index) => {
    if (index === 0) return
    rollback(item.data, ownQueue[0])
  })

  return ownQueue
}

/**
 * 获取当前光标位置，当选择部分字符以及移动光标位置，请使用selection-change回调获取光标位置
 * 本方法是为了弥补在输入（粘贴）的时候，不会触发selection-change的问题
 * @param quill
 * @return {*|number|((name: string) => IDBIndex)}
 */
export function getCurCursorPosition (quill) {
  if (quill.hasFocus()) return quill.getSelection().index
  return null
}

/**
 * 返回当前同步状态
 * @return {Boolean}
 */
export function wrapType (wrapType) {
  if (typeof wrapType !== 'undefined') {
    Storage.storage('curWrapType', wrapType)
  } else {
    return Storage.storage('curWrapType')
  }
}

/**
 * 中文锁
 * @param cacheOps
 * @return {*}
 */
export function chineseLock (messageLock) {
  if (typeof messageLock !== 'undefined') {
    Store.store('chineseLock', messageLock)
  } else {
    return Store.store('chineseLock')
  }
}

/**
 * 返回当前编辑器中的文本
 * @param quill
 * @return {string}
 */
export function getEditorText (quill) {
  return quill.container.firstChild.innerText
}

/**
 * 返回当前选中文本的样式
 * @param quill
 * @param range
 * @param length
 * @return {*}
 */
export function getStyle (quill, range, length = 0) {
  if (!quill) return
  if (range) return quill.getFormat(range, length)
  return quill.getFormat()
}

/**
 * 返回当前同步状态
 * @return {Boolean}
 */
export function isSelectAll (boolean) {
  if (typeof boolean !== 'undefined') {
    Store.store('isSelectAll', boolean)
  } else {
    return Store.store('isSelectAll')
  }
}

/**
 * 返回当前同步状态
 * @return {Boolean}
 */
export function isSyncing (sync) {
  if (typeof sync !== 'undefined') {
    Store.store('isSyncing', sync)
  } else {
    return Store.store('isSyncing')
  }
}

/**
 * 返回当前删除锁状态
 * @return {Boolean}
 */
export function deleteLock (deleteLock) {
  if (typeof deleteLock !== 'undefined') {
    Storage.storage('deleteLock', deleteLock)
  } else {
    return Storage.storage('deleteLock')
  }
}

/**
 * 返回某一次副本的内容
 * @return {Boolean}
 */
export function curContentCopy (content) {
  if (typeof content !== 'undefined') {
    Store.store('curContentCopy', content)
  } else {
    return Store.store('curContentCopy')
  }
}

/**
 * 根据收到的消息来返回当前用户需要的数据
 * @param data
 * @param accountId
 */
export function getSocketContent (data, accountId) {
  let receiveData = {}

  try {
    receiveData = JSON.parse(data)
  } catch (e) {
    console.log(e)
  }

  if (!receiveData.collaboratorInfo || !receiveData.collaboratorInfo.account_id) return null

  if (accountId === receiveData.collaboratorInfo.account_id) {
    return receiveData['private'][1].data
  } else {
    return receiveData['others'][1].data
  }
}

/**
 * 返回当前副本的内容
 * @return {Boolean}
 */
export function historyContentCopy (content) {
  if (typeof content !== 'undefined') {
    Store.store('historyContentCopy', content)
  } else {
    return Store.store('historyContentCopy')
  }
}

/**
 * 返回本次操作的delta
 * @return {Boolean}
 */
export function curOpsDelta (curOps) {
  if (typeof curOps !== 'undefined') {
    Store.store('curOpsDelta', curOps)
  } else {
    return Store.store('curOpsDelta')
  }
}

/**
 * 返回本次操作的delta
 * @return {Boolean}
 */
export function ownOperationQueue (ownOperation) {
  if (typeof ownOperation !== 'undefined') {
    Store.store('ownOperationQueue', ownOperation)
  } else {
    return Store.store('ownOperationQueue')
  }
}

export function receiveOperationQueue (receiveOperation) {
  if (typeof receiveOperation !== 'undefined') {
    Store.store('receiveOperationQueue', receiveOperation)
  } else {
    return Store.store('receiveOperationQueue')
  }
}

/**
 * 返回当前副本的内容
 * @return {Boolean}
 */
export function cacheLock (lock) {
  if (typeof lock !== 'undefined') {
    Store.store('cacheLock', lock)
  } else {
    return Store.store('cacheLock')
  }
}

/**
 * 返回当前markdown解析状态
 * @return {Boolean}
 */
export function markdownLock (markdownLock) {
  if (typeof markdownLock !== 'undefined') {
    Store.store('markdownLock', markdownLock)
  } else {
    return Store.store('markdownLock')
  }
}

/**
 * 获取当前编辑器中的文本长度
 * @param quill
 * @return {number}
 */
export function getCurLength (quill) {
  return quill.getLength()
}

/**
 * 获取当前编辑器选中的文本长度
 * @param length
 * @return {number}
 */
export function selectLength (length) {
  if (typeof length !== 'undefined') {
    Store.store('curSelectLength', length)
  } else {
    return Store.store('curSelectLength')
  }
}

/**
 * 获取当前光标处的位置坐标
 * @param quill
 * @return {*}
 */
export function getCurSelectBounds (quill) {
  if (!quill) return
  let curSelectLength = selectLength()
  let curCursorPosition = getCurCursorPosition(quill)

  console.log(curSelectLength, curCursorPosition)

  if (curCursorPosition) {
    return quill.getBounds(curCursorPosition, curSelectLength)
  }
}

/**
 * 获取富文本编辑器中的纯文本
 * 如果要获取html内容请用dom操作：quill.container.firstChild.innerHTML
 * @param quill
 * @param start 开始位置索引
 * @param end 结束索引，默认为当前剩余文档的长度
 * @return {*}
 */
export function getCurText (quill, start, end) {
  return quill.getText(start, end)
}

export function patchEnter (str) {
  return str.match(/(\n)/g) ? str.match(/(\n)/g).length : 0
}



// WEBPACK FOOTER //
// ./src/mixin/docs.js